module.exports = __webpack_public_path__ + "static/media/mlv-auto-currency-switcher.8a9ea420.png";